import React from "react";
import EventFormWizard from "@/components/student/EventFormWizard";

/**
 * Organizer event creation — the web port of the RN create-event wizard
 * (`SocietyAndImageScreen` → `EventInformationScreen` → `DateAndTimeScreen`).
 * The step content and submission live in
 * `EventFormWizard`; this page only mounts it in create mode.
 */
const StudentCreateEventPage: React.FC = () => (
  <EventFormWizard mode="create" />
);

export default StudentCreateEventPage;
